<template>
  <div>
    <div
      class="container-xl bg-primary hero-header animate__animated animate__zoomIn"
    >
      <div class="container px-lg-5">
        <div class="row g-5">
          <div class="col-lg-8 text-center text-lg-start">
            <h3
              class="mb-4 animate__animated animate__slideInDown text--white animate__delay-1s"
            >
              امکانات نامیا
            </h3>
            <p
              class="pb-3 animate__animated animate__zoomIn text--white animate__delay-1s"
            >
              کیوسک هوشمند ارتباط با مشتری،نامیا برای اولین بار در کشور انواع
              کیوسک 8اینچ ،6.5اینچ ،10اینچ، 24اینچ با 29سامانه ارتباط با مشتری
              طراحی نموده است و نیاز کسب وکارها را هوشمند می کند
            </p>

            <v-btn
              rounded
              href=""
              class="btn btn-primary-gradient py-sm-3 px-4 px-sm-5 me-3 animate__animated animate__zoomIn animate__delay-1s animate__fast"
              >درباره ما</v-btn
            >
            <v-btn
              rounded
              href=""
              class="btn btn-secondary-gradient py-sm-3 px-4 px-sm-5 animate__animated animate__zoomIn animate__delay-1s animate__fast"
              >ارتباط با ما</v-btn
            >
          </div>
          <div
            class="col-lg-4 text-center justify-content-center animate__animated animate__zoomIn animate__delay-2s animate__fast"
          >
            <v-img
              class="rounded mr-10 showOnlyLg"
              :src="customers.image"
              width="70%"
              height="auto"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Features Start -->
    <div class="container-xxl py-5" id="feature">
      <div class="container py-5 px-lg-5">
        <div
          class="text-center wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <h5 class="text-primary-gradient fw-medium">امکانات نامیا</h5>
          <h3 class="mb-5">امکانات نامیا</h3>
        </div>
        <div class="row g-4 justify-center">
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-center justify-content-center bg-primary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/book.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">ایجاد کاتالوگ دیجیتال</h5>
              <p class="ma-0">
                تنها با چند کلیک با بارگذاری تصاویر یا pdf کاتالوگ مورد نظر
                خودرا ایجاد کنید و آن را ازطریق پیامک، شبکه های اجتماعی، وب سایت
                خود به نمایش بگذارید.
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.3s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/panaroma.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">تور مجازی</h5>
              <p class="ma-0">
                تورمجازی 360 درجه نامیا امکان نمایش 3 بعدی محیط کسب و کار را
                ایجاد کرده است
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-center justify-content-center bg-primary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/camera.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">گالری فیلم و عکس</h5>
              <p class="ma-0">
                شما می‌توانید در اپ نامیا برای کسب و کار خود یک گالری عکس و فیلم
                از مجموعه،محصولات،خدمات و... ایجاد کنید
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-primary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/customer.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">باشگاه مشتریان</h5>
              <p class="ma-0">
                ایجاد ارتباط دوطرفه با مشتریان و همچنین امکان ایجاد دسته بندیهای
                مورد نظر و دسترسی راحت و سریع تر به مشتریان
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-primary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/document.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">کارت ویزیت دیجیتال</h5>
              <p class="ma-0">
                با وارد کردن شماره مورد نظر کارت ویزیت ارسال شده و همچنین امکان
                ایجادQR وجود دارد. فرد موردنظربا دریافت کارت ویزیت به باشگاه
                مشتریان شما اضافه میشود
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/avatar.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">نامیاب</h5>
              <p class="ma-0">
                جادویی هوشمند برای نمایش نام مشتریان، با وارد کردن شماره موبایل
                نام مشتریان خودکار نمایش داده میشود
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.3s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-primary-gradient rounded-circle mb-4"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/birthday.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">سامانه تولد</h5>
              <p class="ma-0">
                با ثبت تاریخ تولد مشتریان در روز تولدشان پیامک متنی یا صوتی
                دلخواه خودکار ارسال میشود
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/feedback.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">نظرسنجی</h5>
              <p class="ma-0">
                روشی بسیار موثر برای جمع اوری نظرات و پیشنهادات مشتریان است که
                سبب رفع نواقص، بهبود کیفیت خدمات کسب و کارها، افزایش رضایت
                مشتریان میشود
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/I-win.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">قرعه‌کشی</h5>
              <p class="ma-0">
                روشی بسیار موثر برای جذب مشتریان جدید و حفظ مشتریان قدیمی که به
                دو روش طراحی شده است 1.پیامکی 2.بارگذاری شماره موبایل
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/wheel.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">گردونه شانس</h5>
              <p class="ma-0">
                روشی برای جذب مشتریان با جذابیت بالا و سرگرمی که به چند روش
                میتواند برای مشتری پیامک شود 1.پیامک انبوه 2.زمان عضویت درباشگاه
                مشتریان ۳.روز تولد مشتریان
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/sms.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">سامانه پیامک</h5>
              <p class="ma-0">
                امکان ارسال پیامک به اصناف، موقعیت های مکانی مختلف، استان و
                شهرهای مختلف را ایجاد کرده است
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/microphone.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">پیامک صوتی</h5>
              <p class="ma-0">
                شما می‌توانید با ضبط یک صدا به صورت تلفن گویا به تبلیغات کسب و
                کار خود بپردازید.
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/sms.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">ارسال انبوه سیم کارت،واتسآپ و ایتا</h5>
              <p class="ma-0">
                امکان تبلیغات انبوه با استفاده از ایتا،واتساپ، سامانه
                پیامک،پیامک صوتی،پیامک با شماره همراه
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/food-truck.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">رستوران</h5>
              <p class="ma-0">
                کسب و کار های رستورانی و سفارش آنلاین می‌توانند با خرید پکیج
                رستورانی ما از امکانات ویژه ای جهت هوشمند سازی رستوران خود
                بهره‌مند شوند
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/basket.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">فروشگاه آنلاین</h5>
              <p class="ma-0">
                شما می‌توانید برای کسب و کار خود یک فروشگاه اینترنتی ایجاد کنید
                و به صورت آنلاین به فروش محصولات خود پردازید.
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/coin.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">درگاه پرداخت</h5>
              <p class="ma-0">
                با وارد کردن شماره مشتری و مبلغ صورتحساب لینک پرداخت ارسال شده و
                مشتریان مستقیم به درگاه پرداخت اینترنتی متصل میشوند
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/factor.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">سامانه فاکتور</h5>
              <p class="ma-0">
                به راحتی برای مشتریان خود فاکتور صادر کرده و بلافاصله پس از صدور
                فاکتو، پیامکی حاوی اطلاعات فاکتور برای مشتری مورد نظر ارسال
                میشود
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/credit.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">سامانه اعتبار</h5>
              <p class="ma-0">
                بعد از هر خرید مشتری، صاحب کسب و کار می تواند نسبت به مبلغ
                خریداری شده اعتباری جهت خرید های آینده این مشتری تایین نماید
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/alarm.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">قرار ملاقات</h5>
              <p class="ma-0">
                ثبت قرارملاقات و تعیین زمان ارسال پیامک خودکار یادآوری قرار
                ملاقات
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/qr-code.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">QR هوشمند</h5>
              <p class="ma-0">
                امکان دریافت انتقادات و پیشنهادات بصورت: متن، صوت، تصویر
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-md-6 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="feature-item bg-light rounded pa-4 text-center">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle mb-4 white--text"
                style="
                  width: 60px;
                  height: 60px;
                  justify-content: center;
                  align-items: center;
                "
              >
                <img
                  class="gif"
                  src="../assets/images/animated icon/park.gif.gif"
                  alt=""
                />
              </div>
              <h5 class="mb-3">سامانه پارکینگ</h5>
              <p class="ma-0">
                اگر شما برای کسب و کار خود پارکینگ اختصاصی دارین میتوانید با
                سامانه پارکینگ هوشمند نامیا تمامی ورودی و خروجی در پارکینگ را
                مشاهده فرمایید
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Features End -->

    <!-- Screenshot Start -->
    <div class="container-xxl py-5">
      <div class="container py-5 px-lg-5">
        <div class="row g-5 align-items-center">
          <div
            class="col-lg-8 wow animate__animated animate__fadeInUp align-self-center pa-14"
            data-wow-delay="0.1s"
          >
            <h5 class="text-primary-gradient fw-medium">نمایی از نامیا</h5>
            <h4 class="mb-4">رابط کاربری ساده و آسان</h4>
            <p class="mb-4" style="">
              خیلی ساده با چند کلیک کسب و کار خود را در برنامه نامیا اضافه کنید
              به بعد از احراز هویت، تایید و خرید پکیج انتخابی دستیار هوشمند کسب
              و کار خود را داشته باشید.
            </p>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 512 512"
                class="svgColor"
              >
                <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                />
              </svg>
              رابط کاربری ساده
            </p>
            <p>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 512 512"
                class="svgColor"
              >
                <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                />
              </svg>
              امکانات ویژه برای کسب و کار ها
            </p>
            <p class="mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="1em"
                viewBox="0 0 512 512"
                class="svgColor"
              >
                <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                <path
                  d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                />
              </svg>
              ارسال انبوه پیامک از ایتا و واسآپ
            </p>
            <!-- <v-btn
              rounded
              href=""
              class="btn btn-primary-gradient py-sm-3 px-4 px-sm-5 rounded-pill mt-3"
              >Read More</v-btn
            > -->
          </div>
          <div
            class="col-lg-4 d-flex justify-content-center justify-content-lg-end wow animate__animated animate__fadeInUp"
            data-wow-delay="0.3s"
            style="
              visibility: visible;
              animation-delay: 0.3s;
              animation-name: fadeInUp;
              justify-content: center;
            "
          >
            <div class="owl-carousel screenshot-carousel owl-loaded owl-drag">
              <div class="owl-stage-outer">
                <!-- transform: translate3d(-892px, 0px, 0px); -->
                <div
                  class="owl-stage"
                  style="transition: all 1s ease 0s; width: 2453px"
                >
                  <div class="owl-item cloned" style="width: 223px">
                    <img
                      class="img-fluid"
                      src="../assets/img/namya.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <!-- <div class="owl-nav disabled">
                <div class="owl-prev">prev</div>
                <div class="owl-next">next</div>
              </div> -->
              <!-- <div class="owl-dots">
                <div class="owl-dot"><span></span></div>
                <div class="owl-dot active"><span></span></div>
                <div class="owl-dot"><span></span></div>
                <div class="owl-dot"><span></span></div>
                <div class="owl-dot"><span></span></div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Screenshot End -->

    <!-- Process Start -->
    <div class="container-xxl py-5">
      <div class="container py-5 px-lg-5">
        <div
          class="text-center pb-4 wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <h5 class="text-primary-gradient fw-medium">
            چجوری نامیا رو سفارش بدم؟
          </h5>
          <h3 class="mb-5">با 3 مرحله ساده</h3>
        </div>
        <div class="row gy-5 gx-4 justify-content-center">
          <div
            class="col-lg-4 col-sm-6 text-center pt-4 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.1s"
          >
            <div class="position-relative bg-light rounded pt-5 pb-4 px-4">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-primary-gradient rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style="
                  width: 100px;
                  height: 100px;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 512 512"
                >
                  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
                  />
                </svg>
              </div>
              <h5 class="mt-4 mb-3">انتخاب پلن و ثبت سفارش نامیا</h5>
              <p class="mb-0">
                با انتخاب پلن مد نظر نسبت به کسب و کار خود می توانید از امکانات
                پلن انتخابی خود در برنامه استفاده فرمایید
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6 text-center pt-4 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.3s"
          >
            <div class="position-relative bg-light rounded pt-5 pb-4 px-4">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-secondary-gradient rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style="
                  width: 100px;
                  height: 100px;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 576 512"
                >
                  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
                  />
                </svg>
              </div>
              <h5 class="mt-4 mb-3">آموزش نرم افزار طبق پلن خریداری شده</h5>
              <p class="mb-0">
                بعد از خرید پلن،تیم آموزش به صورت 24/7 جهت آموزش همکاران شما در
                خدمت گذاری حاظر هستند
              </p>
            </div>
          </div>
          <div
            class="col-lg-4 col-sm-6 text-center pt-4 wow animate__animated animate__fadeInUp"
            data-wow-delay="0.5s"
          >
            <div class="position-relative bg-light rounded pt-5 pb-4 px-4">
              <div
                class="d-inline-flex align-items-center justify-content-center bg-primary-gradient rounded-circle position-absolute top-0 start-50 translate-middle shadow"
                style="
                  width: 100px;
                  height: 100px;
                  align-items: center;
                  justify-content: center;
                "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  height="1em"
                  viewBox="0 0 512 512"
                >
                  <!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                  <path
                    d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
                  />
                </svg>
              </div>
              <h5 class="mt-4 mb-3">استفاده مادام العمر از سیستم</h5>
              <p class="mb-0">
                با انتخاب هر کدام از پلن ها انتخابی، شما می توانید بدون هزینه
                سالیانه از برنامه نامیا استفاده فرمایید
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Process Start -->

    <!-- Download Start -->
    <div class="container-xxl py-5">
      <div class="container py-5 px-lg-5">
        <div class="row g-5 align-items-center">
          <div class="col-lg-6">
            <v-img
              class="rounded mr-10 showOnlyLg"
              :src="customers.image"
              width="70%"
              height="auto"
            />
          </div>
          <div
            class="col-lg-6 wow animate__animated animate__fadeInUp align-self-center"
            data-wow-delay="0.3s"
          >
            <h5 class="text-primary-gradient fw-medium">دانلود</h5>
            <h3 class="mb-4">دانلود آخرین نسخه برنامه</h3>
            <p class="mb-4">
              جهت دانلود آخرین نسخه برنامه بر روی گزینه کلیک فرمایید
            </p>
            <div class="row g-4">
              <div
                class="col-sm-6 wow animate__animated animate__fadeIn"
                data-wow-delay="0.5s"
              >
                <v-btn
                  block
                  class="bg-secondary-gradient rounded white--text"
                  rounded
                  x-large
                  color="blue-grey"
                >
                  دانلود آخرین نسخه نامیا
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Download End -->

    <!-- Pricing Start -->
    <!-- <div class="container-xxl py-5" id="pricing"> -->
    <!-- <div class="container py-5 px-lg-5"> -->
    <!-- <div
          class="text-center pb-4 wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <h5 class="text-primary-gradient fw-medium">قیمت گذاری پلن ها</h5>
          <h3 class="mb-5">امکانات و قیمت هر پلن</h3>
        </div> -->
    <!-- <div
          class="tab-class text-center pricing wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <div class="tab-content text-start">
            <div id="tab-1" class="tab-pane fade show pa-0 active">
              <div class="row g-4">
                <div class="col-lg-3">
                  <div class="bg-light rounded">
                    <div class="border-bottom pa-4 mb-4">
                      <h4 class="text-primary-gradient mb-1">پلن امگا</h4>
                      <span>امکانات پلن امگا</span>
                    </div>
                    <div class="pa-4 pt-0">
                      <h3 class="mb-3 text-center">
                        {{ (5000000).toLocaleString()
                        }}<small
                          class="align-top mx-1"
                          style="font-size: 15px; line-height: 45px"
                          >ءتء</small
                        >
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="bg-light rounded border">
                    <div class="border-bottom pa-4 mb-4">
                      <h4 class="text-primary-gradient mb-1">پلن سیگما</h4>
                      <span>امکانات پلن سیگما</span>
                    </div>
                    <div class="pa-4 pt-0">
                      <h3 class="mb-3 text-center">
                        {{ (10000000).toLocaleString()
                        }}<small
                          class="align-top mx-1"
                          style="font-size: 15px; line-height: 45px"
                          >ءتء</small
                        >
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="bg-light rounded">
                    <div class="border-bottom pa-4 mb-4">
                      <h4 class="text-primary-gradient mb-1">پلن دلتا</h4>
                      <span>امکانات پلن دلتا</span>
                    </div>
                    <div class="pa-4 pt-0">
                      <h3 class="mb-3 text-center">
                        {{ (15000000).toLocaleString()
                        }}<small
                          class="align-top mx-1"
                          style="font-size: 15px; line-height: 45px"
                          >ءتء</small
                        >
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <div class="bg-light rounded">
                    <div class="border-bottom pa-4 mb-4">
                      <h4 class="text-primary-gradient mb-1">پلن الفا</h4>
                      <span>امکانات پلن الفا</span>
                    </div>
                    <div class="pa-4 pt-0">
                      <h3 class="mb-3 text-center">
                        {{ (25000000).toLocaleString()
                        }}<small
                          class="align-top mx-1"
                          style="font-size: 15px; line-height: 45px"
                          >ءتء</small
                        >
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
    <!-- </div> -->
    <!-- </div> -->
    <!-- Pricing End -->

    <!-- Testimonial Start -->
    <!-- <div class="container-xxl py-5" id="review">
      <div class="container py-5 px-lg-5">
        <div
          class="text-center wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <h5 class="text-primary-gradient fw-medium">Testimonial</h5>
          <h3 class="mb-5">What Say Our Clients!</h3>
        </div>
        <div
          class="owl-carousel testimonial-carousel wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <div class="testimonial-item rounded pa-4">
            <div class="d-flex align-items-center mb-4">
              <img
                class="img-fluid bg-white rounded flex-shrink-0 pa-1"
                src="../assets/img/testimonial-1.jpg"
                style="width: 85px; height: 85px"
              />
              <div class="ms-4">
                <h5 class="mb-1">Client Name</h5>
                <p class="mb-1">Profession</p>
                <div>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                </div>
              </div>
            </div>
            <p class="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div class="testimonial-item rounded pa-4">
            <div class="d-flex align-items-center mb-4">
              <img
                class="img-fluid bg-white rounded flex-shrink-0 pa-1"
                src="../assets/img/testimonial-2.jpg"
                style="width: 85px; height: 85px"
              />
              <div class="ms-4">
                <h5 class="mb-1">Client Name</h5>
                <p class="mb-1">Profession</p>
                <div>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                </div>
              </div>
            </div>
            <p class="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div class="testimonial-item rounded pa-4">
            <div class="d-flex align-items-center mb-4">
              <img
                class="img-fluid bg-white rounded flex-shrink-0 pa-1"
                src="../assets/img/testimonial-3.jpg"
                style="width: 85px; height: 85px"
              />
              <div class="ms-4">
                <h5 class="mb-1">Client Name</h5>
                <p class="mb-1">Profession</p>
                <div>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                </div>
              </div>
            </div>
            <p class="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
          <div class="testimonial-item rounded pa-4">
            <div class="d-flex align-items-center mb-4">
              <img
                class="img-fluid bg-white rounded flex-shrink-0 pa-1"
                src="../assets/img/testimonial-4.jpg"
                style="width: 85px; height: 85px"
              />
              <div class="ms-4">
                <h5 class="mb-1">Client Name</h5>
                <p class="mb-1">Profession</p>
                <div>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                  <small class="fa fa-star text-warning"></small>
                </div>
              </div>
            </div>
            <p class="mb-0">
              Tempor erat elitr rebum at clita. Diam dolor diam ipsum sit diam
              amet diam et eos. Clita erat ipsum et lorem et sit.
            </p>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Testimonial End -->

    <!-- Contact Start -->
    <!-- <div class="container-xxl py-5" id="contact">
      <div class="container py-5 px-lg-5">
        <div
          class="text-center wow animate__animated animate__fadeInUp"
          data-wow-delay="0.1s"
        >
          <h5 class="text-primary-gradient fw-medium">Contact Us</h5>
          <h3 class="mb-5">Get In Touch!</h3>
        </div>
        <div class="row justify-content-center">
          <div class="col-lg-9">
            <div
              class="wow animate__animated animate__fadeInUp"
              data-wow-delay="0.3s"
            >
              <p class="text-center mb-4">
                The contact form is currently inactive. Get a functional and
                working contact form with Ajax & PHP in a few minutes. Just copy
                and paste the files, add a little code and you're done.
                <a href="https://htmlcodex.com/contact-form">Download Now</a>.
              </p>
              <form>
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        placeholder="Your Name"
                      />
                      <label for="name">Your Name</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-floating">
                      <input
                        type="email"
                        class="form-control"
                        id="email"
                        placeholder="Your Email"
                      />
                      <label for="email">Your Email</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <input
                        type="text"
                        class="form-control"
                        id="subject"
                        placeholder="Subject"
                      />
                      <label for="subject">Subject</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-floating">
                      <textarea
                        class="form-control"
                        placeholder="Leave a message here"
                        id="message"
                        style="height: 150px"
                      ></textarea>
                      <label for="message">Message</label>
                    </div>
                  </div>
                  <div class="col-12 text-center">
                    <button
                      class="btn btn-primary-gradient rounded-pill py-3 px-5"
                      type="submit"
                    >
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Contact End -->
  </div>
</template>

<script>
export default {
  props: {
    customers: {},
    customersAbout: {},
  },
};
</script>
<style>
* {
  letter-spacing: 0;
}
:root {
  --primary: #0aab94;
  --secondary: #5fbc5e;
  --light: #f0f6ff;
  --dark: #262b47;
}
</style>
<style scoped>
svg {
  scale: 1.2;
  color: white;
}
/*** Heading ***/
h1,
h2,
.fw-bold {
  font-weight: 500 !important;
}
p {
  font-weight: 900 !important;
}
h3,
h4,
.fw-semi-bold {
  font-weight: 500 !important;
}

h5,
h6,
.fw-medium {
  font-weight: 500 !important;
}

/*** Gradient Text & BG ***/
.text-primary-gradient {
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-secondary-gradient {
  background: linear-gradient(
    to bottom right,
    var(--secondary),
    var(--primary)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.bg-primary-gradient {
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
}

.bg-secondary-gradient {
  background: linear-gradient(
    to bottom right,
    var(--secondary),
    var(--primary)
  );
}

/*** Button ***/
.btn {
  transition: 0.5s;
}

.btn.btn-primary-gradient,
.btn.btn-secondary-gradient {
  position: relative;
  overflow: hidden;
  border: none;
  color: #ffffff;
  z-index: 1;
}

.btn.btn-primary-gradient::after,
.btn.btn-secondary-gradient::after {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: 0.5s;
  z-index: -1;
  opacity: 0;
}

.btn.btn-primary-gradient,
.btn.btn-secondary-gradient::after {
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
}

.btn.btn-secondary-gradient,
.btn.btn-primary-gradient::after {
  background: linear-gradient(
    to bottom right,
    var(--secondary),
    var(--primary)
  );
}

.btn.btn-primary-gradient:hover::after,
.btn.btn-secondary-gradient:hover::after {
  opacity: 1;
}

.btn-square {
  width: 38px;
  height: 38px;
}

.btn-sm-square {
  width: 32px;
  height: 32px;
}

.btn-lg-square {
  width: 48px;
  height: 48px;
}

.btn-square,
.btn-sm-square,
.btn-lg-square {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  border-radius: 50px;
}

.back-to-top {
  position: fixed;
  display: none;
  right: 45px;
  bottom: 45px;
  z-index: 99;
  border: none;
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
}

/*** Navbar ***/
.navbar-light .navbar-nav .nav-link {
  position: relative;
  margin-right: 25px;
  padding: 45px 0;
  font-family: "Jost", sans-serif;
  font-size: 18px;
  font-weight: 200;
  color: var(--light) !important;
  outline: none;
  transition: 0.5s;
}

.navbar-light .navbar-nav .nav-link::before {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
  border: 10px solid;
  border-color: var(--light) transparent transparent transparent;
  transition: 0.5s;
}

.sticky-top.navbar-light .navbar-nav .nav-link {
  padding: 20px 0;
  color: var(--dark) !important;
}

.navbar-light .navbar-nav .nav-link:hover::before,
.navbar-light .navbar-nav .nav-link.active::before {
  top: 0;
}

.navbar-light .navbar-brand h1 {
  color: #ffffff;
}

.navbar-light .navbar-brand img {
  max-height: 60px;
  transition: 0.5s;
}

.sticky-top.navbar-light .navbar-brand img {
  max-height: 45px;
}

@media (max-width: 991.98px) {
  .sticky-top.navbar-light {
    position: relative;
    background: #ffffff;
  }

  .navbar-light .navbar-collapse {
    margin-top: 15px;
    border-top: 1px solid #dddddd;
  }

  .navbar-light .navbar-nav .nav-link,
  .sticky-top.navbar-light .navbar-nav .nav-link {
    padding: 10px 0;
    margin-left: 0;
    color: var(--dark) !important;
  }

  .navbar-light .navbar-nav .nav-link::before {
    display: none;
  }

  .navbar-light .navbar-nav .nav-link:hover,
  .navbar-light .navbar-nav .nav-link.active {
    color: var(--primary) !important;
  }

  .navbar-light .navbar-brand h1 {
    background: linear-gradient(
      to bottom right,
      var(--primary),
      var(--secondary)
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .navbar-light .navbar-brand img {
    max-height: 45px;
  }
}

@media (min-width: 992px) {
  .navbar-light {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 999;
  }

  .sticky-top.navbar-light {
    position: fixed;
    background: #ffffff;
  }

  .sticky-top.navbar-light .navbar-nav .nav-link::before {
    border-top-color: var(--primary);
  }

  .sticky-top.navbar-light .navbar-brand h1 {
    background: linear-gradient(
      to bottom right,
      var(--primary),
      var(--secondary)
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}

/*** Hero Header ***/
.hero-header {
  padding: 5rem 0px 10rem 0;
  background: url(../assets/img/bg-circle.png),
    url(../assets/img/bg-triangle.png), url(../assets/img/bg-bottom.png),
    linear-gradient(to bottom right, var(--primary), var(--secondary));
  background-position: left 0px top 0px, right 0px top 50%, center bottom;
  background-repeat: no-repeat;
}

@media (max-width: 991.98px) {
  .hero-header {
    padding: 6rem 0 11rem 0;
  }
}

/*** Feature ***/
.feature-item {
  transition: 0.5s;
  border: 2px solid #28b181;
  height: 230px;
}

.feature-item:hover {
  margin-top: -15px;
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.08);
}

/*** Pricing ***/
.pricing .nav {
  padding: 2px;
}
* {
  font-family: IRANSansX, sans-serif !important;
  line-height: 1.5;
  letter-spacing: 0;
}

.pricing .nav-link {
  padding: 12px 30px;
  font-weight: 200;
  color: var(--dark);
  background: #ffffff;
}

.pricing .nav-item:first-child .nav-link {
  border-radius: 30px 0 0 30px;
}

.pricing .nav-item:last-child .nav-link {
  border-radius: 0 30px 30px 0;
}

.pricing .nav-link.active {
  color: #ffffff;
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
}

/*** Screenshot ***/
.screenshot-carousel {
  position: relative;
  width: 253px;
  height: 500px;
  padding: 15px;
  /* margin-right: 50px; */
}

.screenshot-carousel::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url(../assets/images/screenshot-frame.png) center center no-repeat;
  background-size: 253px 500px;
  z-index: 1;
}

.screenshot-carousel .owl-item img {
  position: relative;
  margin-top: 50px;
  width: 223px;
  height: 330px;
  scale: 1.2;
}

.screenshot-carousel .owl-dots {
  position: absolute;
  top: 50%;
  right: -30px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.screenshot-carousel .owl-dot {
  position: relative;
  display: inline-block;
  margin: 5px 0;
  width: 15px;
  height: 15px;
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
  border-radius: 15px;
  transition: 0.5s;
}

.screenshot-carousel .owl-dot::after {
  position: absolute;
  content: "";
  width: 5px;
  height: 5px;
  top: 5px;
  left: 5px;
  background: #ffffff;
  border-radius: 5px;
}

.screenshot-carousel .owl-dot.active {
  box-shadow: 0 0 10px var(--dark);
}

/*** Testimonial ***/
.testimonial-carousel .owl-item .testimonial-item,
.testimonial-carousel .owl-item .testimonial-item * {
  transition: 0.5s;
}

.testimonial-carousel .owl-item.center .testimonial-item {
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
}

.testimonial-carousel .owl-item.center .testimonial-item h5,
.testimonial-carousel .owl-item.center .testimonial-item p {
  color: #ffffff !important;
}

.testimonial-carousel .owl-nav {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

.testimonial-carousel .owl-nav .owl-prev,
.testimonial-carousel .owl-nav .owl-next {
  margin: 0 12px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: linear-gradient(
    to bottom right,
    var(--primary),
    var(--secondary)
  );
  border-radius: 60px;
  font-size: 18px;
  transition: 0.5s;
}

.testimonial-carousel .owl-nav .owl-prev:hover,
.testimonial-carousel .owl-nav .owl-next:hover {
  background: linear-gradient(
    to bottom right,
    var(--secondary),
    var(--primary)
  );
}
.img-fluid {
  max-width: 100%;
  height: auto;
}
.bg-light {
  background-color: #f0f6ff !important;
}
* >>> .rounded {
  border-radius: 10px !important;
}
div.d-flex.justify-content-between.mb-3,
div.d-flex.justify-content-between.mb-2 {
  justify-content: space-between;
}
.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}
div.bg-primary-gradient svg,
div.bg-secondary-gradient svg {
  fill: white;
  scale: 1.3;
}
.text--white {
  color: white;
}
div.d-flex.justify-content-between svg {
  fill: #0aab94;
}
.svgColor {
  fill: #0aab94;
}
img.gif {
  width: 50px;
  height: 50px;
}
h3.mb-3.text-center {
  color: #0aab94;
}
@media only screen and (max-width: 900px) {
  .showOnlyLg {
    display: none;
  }
}
.border-bottom.pa-4.mb-4 {
  text-align: center;
}
div.position-relative.bg-light.rounded.pt-5.pb-4.px-4 {
  border: 2px solid #45b76e;
}
.col-lg-3 .bg-light.rounded {
  border: 2px solid #45b76e;
}
</style>
